module.exports = __webpack_public_path__ + "img/资产-苹果手机标签.8a0c4122.jpg";